import { Button, Text } from "@jds/core";
import limitedAccess from "../../../assets/png/limitedaccess.png";
import { useDispatch, useSelector } from "react-redux";
import {
  setAccessModalClose,
  setPlanModalClose,
  setSubscriptionPlan,
} from "../../../store/state-slices/plans";
const AccessAlert = () => {
  const dispatch = useDispatch();
  const { accessMsg } = useSelector((state) => state.plans);
  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <img
          src={limitedAccess}
          alt="limitedAccess"
          style={{ width: "164px", height: "187px", marginInline: "auto" }}
        />
        <Text appearance="body-l-bold" text="Limited Access" />
        <Text
          appearance="body-m"
          text={accessMsg || "Upgrade your plan to create more events"}
          color="primary_grey_80"
        />
        <div
          style={{
            alignSelf: "end",
            display: "flex",
            flexDirection: "row",
            gap: "12px",
          }}
        >
          <Button
            kind="secondary"
            label="Dismiss"
            onClick={() => {
              dispatch(setAccessModalClose(true));
            }}
          />
          <Button
            kind="primary"
            label="Subscribe now"
            onClick={() => {
              dispatch(setAccessModalClose(true));
              dispatch(setSubscriptionPlan(true));
              dispatch(setPlanModalClose(false));
            }}
          />
        </div>
      </div>
    </>
  );
};
export default AccessAlert;
